import styled from 'styled-components';

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.red.string()};
  font-size: 0.7em;
  font-weight: ${(props) => props.theme.fontWeightBold};
`;
